var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFieldDatatypeDatetime = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 0h17a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m12.25 12.955q.518 0 .884-.367c.366-.367.366-.538.366-.883v-6.25q0-.518-.366-.884a1.2 1.2 0 0 0-.884-.366h-.625V3.58a.6.6 0 0 0-.18-.445.6.6 0 0 0-.445-.18.6.6 0 0 0-.444.18.6.6 0 0 0-.181.445v.625h-1.25V3.58a.6.6 0 0 0-.18-.445.6.6 0 0 0-.445-.18.6.6 0 0 0-.444.18.6.6 0 0 0-.181.445v.625h-1.25V3.58a.6.6 0 0 0-.18-.445.6.6 0 0 0-.445-.18.6.6 0 0 0-.444.18.6.6 0 0 0-.181.445v.625H8.75q-.518 0-.884.366a1.2 1.2 0 0 0-.366.884v6.25q0 .518.366.883.366.367.884.367zm-1.629-6.576a3 3 0 1 1-4.243 4.242 3 3 0 0 1 4.243-4.242M14.036 7l-1.553 1.39-.919-.822-.064.057-.438.393-.062.055L12.482 9.4 14.6 7.505z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFieldDatatypeDatetime);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/field-datatype-datetime.35eb724c.svg";